enum Category {
  ROBOTICS = 'Robotics',
  PHYSICAL_COMPUTING = 'Physical computing',
  BLOCK_BASED_PROGRAMMING = 'Block-based programming',
  SYNTAX_BASED_PROGRAMMING = 'Syntax-based programming',
  UNPLUGGED = 'Unplugged',
}

export default Category;
